import { Component, ElementRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ExplanationModalComponent } from './explanation-modal/explanation-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'explanation',
    templateUrl: 'explanation.component.html',
    styleUrls: ['./explanation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExplanationComponent implements OnInit {


	@Input() explanationText: string;
	@Input() drawToBottom = false;
	@Input() drawToTopRight = false;

	constructor(public explanationModalDialog: MatDialog,
				private elRef: ElementRef) {
	}

	ngOnInit(): void {

	}


	openExplanationDialog() {
		this.explanationModalDialog.open(ExplanationModalComponent, {
			data: {
				cardExplanationIconRef: this.elRef.nativeElement.parentNode,
				explanationText: this.explanationText,
				drawToBottom: this.drawToBottom,
				drawToTopRight: this.drawToTopRight
			},
			width: '300px',
			height: '300px'
		});
	}
}
